// extracted by css-extract-rspack-plugin
export default {"root":"root-Iz71iL","copyableValueRow":"copyableValueRow-HeC6w5","copyableValue":"copyableValue-EtJiQK"};